<template>
  <div>
    <app-header title="Media Categories">
      <b-button v-router-link="{name:'mediacategory-editor',params:{id:'new'}}" variant="primary">
        <i class="fa fa-plus-circle" /> New Category
      </b-button>
    </app-header>
    <loading-spinner v-if="!mediacategories" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class=" text-right">
          {{ total }} categories
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card-group columns>
            <b-card no-body
              v-for="category in displayMediacategories"
              :key="category.id"
              v-router-link="{ name: 'mediacategory-detail', params: category }"
              
            >
              <img :src="'https://cdn.gokaizen.com/' + category.thumbnail" alt="" style="max-width:100%;">
              <b-card-body>
                <h3>{{ category.name }}</h3>
              </b-card-body>
            </b-card>
          </b-card-group>
          <infinite-scrolling @infiniteHandler="infiniteHandler" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';

export default {
  name: 'MediaCategoryList',

  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      mediacategories: null,
      page: 1,
      perPage: 7,
    };
  },

  computed: {
    displayMediacategories() {
      return $search(this.mediacategories, this.query).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayMediacategories.length : this.mediacategories.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.mediacategories = await $api.get('/v1/internal/mediacategories');
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.mediacategories.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
